export default __webpack_public_path__ + "static/media/mobile-color.da328471.png";